import api from "@/api";

import deepClone from "@/utils/deep-clone";

const state = {
    listMap: {},
};

const getters = {
    list(state) {
        return id => deepClone(state.listMap[id] ?? []);
    },
};

const actions = {
    getList({ commit }, { payload: { goalId } }) {
        return api.get(`/api/goals/comments/${goalId}`).then(res => {
            const list = res?.data;

            if (list && Array.isArray(list)) {
                commit("updateList", {
                    id: goalId,
                    list,
                });
            }
        });
    },
    create({ commit, state }, { payload: { commentContent, goalId, keyResultId } }) {
        return api
            .post(`/api/goals/comments`, { content: commentContent, goalId, keyResultId })
            .then(res => {
                const comment = res.data;

                const list = getters.list(state)(goalId) || [];
                list.unshift(comment);

                commit("updateList", {
                    id: goalId,
                    list,
                });
            });
    },
    delete({ commit, state }, { payload: { goalId, commentId } }) {
        return api.delete(`/api/goals/comments/${commentId}`).then(() => {
            const list = getters.list(state)(goalId) || [];

            const index = list.findIndex(comment => comment._id === commentId);
            if (index > -1) {
                list.splice(index, 1);

                commit("updateList", {
                    id: goalId,
                    list,
                });
            }
        });
    },
    update({ commit, state }, { payload: { goalId, commentId, commentContent } }) {
        return api
            .post(`/api/goals/comments/${commentId}`, { content: commentContent })
            .then(res => {
                const updatedComment = res.data;

                const list = getters.list(state)(goalId) || [];

                const index = list.findIndex(comment => comment._id === commentId);
                if (index > -1) {
                    list[index] = updatedComment;

                    commit("updateList", {
                        id: goalId,
                        list,
                    });
                }
            });
    },
};

const mutations = {
    updateList(state, { id, list }) {
        state.listMap[id] = [...list];
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
